// Meta Pixel (Facebook Pixel) – DSGVO-konform.
// Lädt ERST nach Marketing-Einwilligung (dh-consent=accepted, siehe CookieBanner).
// ID kommt aus .env: REACT_APP_META_PIXEL_ID

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let loaded = false;

function hasConsent() {
  try {
    return localStorage.getItem("dh-consent") === "accepted";
  } catch {
    return false;
  }
}

function injectPixel() {
  if (loaded || !PIXEL_ID || window.fbq) {
    loaded = loaded || Boolean(window.fbq);
    return;
  }
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0";
    n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  loaded = true;
}

/** Beim App-Start und nach "Alle akzeptieren" aufrufen – lädt nur mit Einwilligung. */
export function bootMetaPixel() {
  if (!PIXEL_ID || !hasConsent()) return;
  injectPixel();
}

/** SPA-Pageview bei Routenwechsel (nur wenn Pixel geladen ist). */
export function metaPageView() {
  if (!loaded || !window.fbq) return;
  window.fbq("track", "PageView");
}

/** Lead-Event nach ERFOLGREICHEM Absenden eines Anfrage-Formulars. */
export function metaLead(source = undefined) {
  if (!loaded || !window.fbq) return;
  window.fbq("track", "Lead", source ? { content_name: source } : undefined);
}
